// extracted by mini-css-extract-plugin
export default {"root":"_13Mqm","small":"_1PhU5","normal":"_1thei"};